import "../../Styles/Auth/Login.css";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import SectionOneLB1 from "../../Assets/SectionOneLB1.png";
import { login } from "../../APIService";
import { ZGAContext } from "../../ZGAContext";

const Login = () => {
  const navigate = useNavigate();
  const { showSuccessModal, setIsSubmitting, setUser } = useContext(ZGAContext);
  const [loginInfo, setLoginInfo] = useState({
    email: "",
    password: "",
  });

  function handleLoginChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    setLoginInfo((prevloginInfo) => {
      return {
        ...prevloginInfo,
        [name]: value,
      };
    });
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const responseData = await login(loginInfo);
      if (responseData.token) {
        setUser(responseData);
        localStorage.setItem("user", JSON.stringify(responseData));
        localStorage.setItem("token", responseData.token);
        showSuccessModal("Login successful!", true, "/", "Home");
      }
    } catch (error) {
      showSuccessModal(`${error.response?.data?.message || "Login failed. Please try again."}`, false, "", "");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login">
      <div>
        <h1>LOGIN</h1>
        <form onSubmit={handleLogin}>
          <fieldset>
            <label>
              Email address
              <input type="email" name="email" required value={loginInfo.email} onChange={handleLoginChange} />
            </label>
            <label>
              Password
              <input
                type="password"
                name="password"
                required
                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                value={loginInfo.password}
                onChange={handleLoginChange}
              />
              <span onClick={() => navigate("/auth/forgotPassword")}>Forgot password?</span>
            </label>
          </fieldset>
          <div>
            <input type="submit" name="submit" value="LOGIN" />
            <span>
              Do you have any account? <span onClick={() => navigate("/auth/signup")}>Signup</span>
            </span>
          </div>
        </form>
      </div>
      <div>
        <img src={SectionOneLB1} alt="Background" />
        <div className="gradient"></div>
      </div>
    </div>
  );
};

export default Login;
